"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushCacheOnce = exports.cacheData = exports.cache = exports.supportsLocalStorage = void 0;
const lodash_once_1 = __importDefault(require("lodash.once"));
const constants_1 = require("../constants");
exports.supportsLocalStorage = lodash_once_1.default(() => {
    const value = '_OMBORI_GRID_SIGNALS_CACHE_TEST';
    try {
        localStorage.setItem(value, value);
        localStorage.removeItem(value);
        return true;
    }
    catch (e) {
        return false;
    }
});
exports.cache = exports.supportsLocalStorage()
    ? JSON.parse(localStorage.getItem(constants_1.EVENTS_CACHE_KEY) || '[]')
    : [];
exports.cacheData = (type, data) => {
    // If the device is offline for a long time we don't want the cache to grow infinitely
    if (exports.cache.length >= 10000) {
        exports.cache.shift();
    }
    exports.cache.push({ type, data });
    exports.supportsLocalStorage() && localStorage.setItem(constants_1.EVENTS_CACHE_KEY, JSON.stringify(exports.cache));
};
const delay = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
const flushCache = (sendOrCacheData) => __awaiter(void 0, void 0, void 0, function* () {
    while (exports.cache.length) {
        const event = exports.cache.shift();
        if (event) {
            sendOrCacheData(event.type, event.data);
            // Don't flush the cache too quickly as it can lead to dropped events
            yield delay(100);
        }
    }
    exports.supportsLocalStorage() && localStorage.removeItem(constants_1.EVENTS_CACHE_KEY);
    exports.flushCacheOnce = lodash_once_1.default(flushCache);
});
exports.flushCacheOnce = lodash_once_1.default(flushCache);
